/* Buch uns: Schritte 1 bis 4, dann Absenden über das Shopify-Kundenformular (Kunde mit Tag event-anfrage + Notiz, Flow verschickt Bestätigung). */
(function () {
  var root = document.getElementById('evb'); if (!root) return;
  var form = document.getElementById('EventForm'); var next = document.getElementById('evb-next'); if (!next) return;
  var back = document.getElementById('evb-back'), bar = document.getElementById('evb-bar'), err = document.getElementById('evb-error');
  var panels = [].slice.call(root.querySelectorAll('.evb__panel')), steps = [].slice.call(root.querySelectorAll('.evb__step'));
  var st = { event: '', offers: [] }, step = 1, booted = false;
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var error = function (m) { err.textContent = m || ''; err.hidden = !m; };
  function paint() {
    panels.forEach(function (p) { p.hidden = Number(p.dataset.panel) !== step; });
    steps.forEach(function (li, i) { li.classList.toggle('is-active', i + 1 === step); li.classList.toggle('is-done', i + 1 < step); });
    bar.style.width = ((step - 1) / 3 * 100) + '%';
    back.hidden = step === 1; next.textContent = step === 4 ? 'Anfrage senden' : 'Weiter'; next.type = step === 4 ? 'submit' : 'button'; error('');
    if (step === 4) recap();
    ready(); if (booted) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
  function ready() {
    var ok = step === 1 ? !!st.event : step === 2 ? st.offers.length > 0 : true;
    next.disabled = !ok;
  }
  function recap() {
    var d = document.getElementById('evb-datum').value.trim(), o = document.getElementById('evb-ort').value.trim(), g = document.getElementById('evb-gaeste').value;
    var parts = [st.event, st.offers.join(', '), [d, o].filter(Boolean).join(' · '), g ? g + ' Gäste' : ''].filter(Boolean);
    document.getElementById('evb-recap').innerHTML = '<strong>Deine Anfrage</strong>' + parts.map(function (p) { return '<span>' + esc(p) + '</span>'; }).join('');
  }
  root.querySelectorAll('[data-event]').forEach(function (b) { b.addEventListener('click', function () {
    st.event = b.dataset.event; root.querySelectorAll('[data-event]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    document.getElementById('evb-eventart').value = st.event; ready();
  }); });
  root.querySelectorAll('[data-offer]').forEach(function (b) { b.addEventListener('click', function () {
    var v = b.dataset.offer, i = st.offers.indexOf(v);
    if (i < 0) st.offers.push(v); else st.offers.splice(i, 1);
    b.setAttribute('aria-pressed', String(i < 0)); document.getElementById('evb-angebot').value = st.offers.join(', '); ready();
  }); });
  next.addEventListener('click', function (e) {
    if (step < 4) { e.preventDefault(); step += 1; paint(); return; }
    var name = document.getElementById('evb-name'), email = document.getElementById('evb-email');
    if (!name.value.trim() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())) { e.preventDefault(); error('Bitte Name und eine gültige E-Mail angeben.'); (name.value.trim() ? email : name).focus(); return; }
    var full = name.value.trim(), sp = full.lastIndexOf(' ');
    document.getElementById('evb-first').value = sp > 0 ? full.slice(0, sp) : full;
    document.getElementById('evb-last').value = sp > 0 ? full.slice(sp + 1) : '-';
    var val = function (id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; };
    var lines = [
      'EVENT-ANFRAGE über sheybi-jewels.de',
      'Event: ' + (st.event || '-'),
      'Angebot: ' + (st.offers.join(', ') || '-'),
      'Datum: ' + (val('evb-datum') || '-'),
      'Ort: ' + (val('evb-ort') || '-'),
      'Gäste: ' + (val('evb-gaeste') || '-'),
      'Name: ' + full,
      'E-Mail: ' + email.value.trim(),
      'Telefon: ' + (val('evb-phone') || '-'),
      'Nachricht: ' + (val('evb-body') || '-'),
      'Gesendet: ' + new Date().toLocaleString('de-DE')
    ];
    document.getElementById('evb-note').value = lines.join('\n');
    document.getElementById('evb-tags').value = 'event-anfrage, event-anfrage-' + Date.now();
    // Kein preventDefault: der Klick auf den Submit-Button sendet das Formular nativ, Shopifys Spam-Schutz hängt sein Token an.
  });
  form.addEventListener('submit', function () { next.disabled = true; next.classList.add('is-loading'); });
  back.addEventListener('click', function () { if (step > 1) { step -= 1; paint(); } });
  form.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') { e.preventDefault(); if (!next.disabled) next.click(); } });
  paint(); booted = true;
})();
